package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.css.DisplayStyle


@Composable
fun CustomTooltip(
    tooltipId: String,
    itemTitle: String,
    placement: PopupPlacement = PopupPlacement.Right,
    showDelay:Int= Constants.showTooltipDelay,
) {
    Tooltip(
        target = ElementTarget.withId(tooltipId),
        text = itemTitle,
        placement =placement,
        hasArrow = false,
        showDelayMs = showDelay,
        modifier = Modifier
            .padding(
                leftRight = Dimen.normalPadding,
                topBottom = Dimen.smallPadding,
            )
            .height(Dimen.menuTooltipHeight)
            .fontWeight(FontWeight.Medium)
            .borderRadius(Dimen.lowBorderRadius)
            .fontFamily(FontFamily.Jakarta)
            .zIndex(Constants.ZIndex.largeZIndex)
            .fontSize(FontSizes.normalFontSize)
            .backgroundColor(Theme.Tooltip.rgb)
            .color(Theme.White.rgb)
            .lineHeight(FontLineHeight.lineNormal)
            .textAlign(TextAlign.Center)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
    )
}
